import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';

// Initialize i18n with HTTP backend loading /locales/{{lng}}/translation.json
// Debug disabled by default; adjust if you need verbose logs locally.
export default i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    debug: false,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });
